import React, { useRef, useState } from 'react';
import { AiOutlineWarning } from 'react-icons/ai';
import { IoNotificationsCircleSharp } from 'react-icons/io5';
import { FaUserCircle } from 'react-icons/fa';
import NotificationsIcon from '@material-ui/icons/Notifications';
import MailIcon from '@material-ui/icons/Mail';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import { BsFillCaretDownFill } from 'react-icons/bs';
import styles from './Header.module.css';
import { IconButton } from '@tmlconnected/avant-garde-components-library';
// import { UserProfile } from '@tmlconnected/avant-garde-components-library';
import UserPofile from '../UserProfile/UserProfile'
import jlrStyles from './HeaderandfooterJlr.module.css'
import { Badge } from '@material-ui/core';

const Header = ({
  otherStyles,
  user,
  logoutUser,
  images,
  config,
  envType,
  supportUrl,
  addSupport,
  MES4,
  backArrowButton,
  handleDrawerToggle,
  isMobile,
  ...other
}) => {
  const [showProfile, setShowProfile] = useState(false);
  const profileRef = useRef(null);

  const renderTestWaterMark = () => (
    <span className={styles.testTitle}>
      <strong>TEST ENVIRONMENT</strong>
      Changes made here will not impact/influence actual Production
    </span>
  );

  return (
    <div className={styles.header} {...otherStyles}>
      <div className={styles.leftContainer}>
        {backArrowButton &&
          <IconButton
            onClick={handleDrawerToggle}>
            {backArrowButton}
          </IconButton>}

        <img className={styles.logo} src={images?.logo} alt="Tata Motors" />
      </div>
      <div>{config?.HOME_UI_BASE_URL?.includes("dev") && renderTestWaterMark()}</div>
      <div className={styles.rightContainer}>
        <div className={styles.topIcons}>
          {/* {user && addSupport && (
            <a
              title="Help & Support"
              target="_blank"
              href={supportUrl}
              rel="noreferrer"
            >
              <img
                src={images?.Support}
                alt="Support"
                className={styles.iconButton}
                style={{ height: '14px', width: '15px', cursor: 'pointer' }}
              />
            </a>
          )} */}
          {/* <AiOutlineWarning className={styles.icDesable} /> */}
          <IconButton className={`${styles.iconButton} ${MES4 ? jlrStyles.iconJlrColor : styles.iconColor}`} >
            {/* <div className={styles.notificationsCount}> */}
            {/* <IoNotificationsCircleSharp className={styles.icDesable} style={{ marginTop: "-11px" }} /> */}
            <Badge  overlap="rectangular" color="secondary" badgeContent={0}>
              <NotificationsIcon />
            </Badge>
            {/* </div> */}
          </IconButton>


          <IconButton
            className={`${styles.iconButton} ${MES4 ? jlrStyles.iconJlrColor : styles.iconColor}`}
            ref={profileRef}
          >
            <AccountCircleIcon
              className={`${styles.iconButton} ${MES4 ? jlrStyles.iconJlrColor : styles.iconColor}`}
              ref={profileRef}
              onClick={() => setShowProfile(true)}
            >
              <BsFillCaretDownFill style={{ marginRight: 0 }} />
            </AccountCircleIcon>
          </IconButton>
          {user && logoutUser && (
            <UserPofile
              open={showProfile}
              anchorEl={profileRef.current}
              handleClose={() => setShowProfile(false)}
              user={user}
              logoutUser={logoutUser}
            />
          )}
        </div>
        {!isMobile &&
          <div className={styles.esakhaContainer}>
            <a href={config?.HOME_UI_BASE_URL} className={styles.homeLink}>
              <span>
                <img
                  src={images?.Esakha || images.logoVariant}
                  className={styles.esakhaLogo}
                  alt={other.alt || 'logo'}
                />
              </span>
            </a>
          </div>
        }
      </div>

    </div>
  );
};

Header.propTypes = {};

export default Header;
